import { useRepositoryMutation } from '@mews-commander/data-access';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useInvalidateReservationGroupQuery } from '@mews-commander/core/entities';
import { RESERVATION_ORDER_ITEMS_EXTENT } from '../../../constants';
import { fetchCurrentEnterpriseCheckedReservations } from '../../../actions';
import { AssignedCategoryFormKeys, AssignedCategoryFormValues } from './types';

export const useChangeAssignedCategoryMutation = (reservationIds: string[], scope: string) => {
    const dispatch = useCommanderThunkDispatch();
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const invalidateReservationsOrderItems = useInvalidateReservationGroupQuery(scope, {
        invalidateOrderItemsQuery: true,
    });
    return useRepositoryMutation('reservations', 'updateAssignedAndRequestedCategory', {
        transformParams: (values: AssignedCategoryFormValues & { updateBlockAvailability: boolean }) => ({
            reservationIds,
            resourceCategoryId: values[AssignedCategoryFormKeys.assignedResourceCategoryId],
            allowRepricing: values[AssignedCategoryFormKeys.updatePrice],
            updateRequestedCategory: values[AssignedCategoryFormKeys.updateRequestedCategory],
            updateBlockAvailability: !!values.updateBlockAvailability,
        }),
        onSuccess: () => {
            if (isReservationModuleReactQueryEnabled) {
                void invalidateReservationsOrderItems();
            } else
                dispatch(fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_ORDER_ITEMS_EXTENT }));
        },
        invalidateQueries: {
            services: ['getAvailabilities'],
            reservations: ['getRequestedCategoryUpdatePriceDifference'],
        },
    });
};
